import * as React from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "components/bootstrap";
import SavedSearchesOverview from "./SavedSearchesOverview";
const SavedSearchesModal = ({ toggleModal, deleteSavedSearch, activeSavedSearchId }) => {
  const { t } = useTranslation("search");
  return /* @__PURE__ */ React.createElement(Modal, { show: true, bsSize: "large", onHide: toggleModal }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, t("saved_searches.title"))), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(
    SavedSearchesOverview,
    {
      deleteSavedSearch,
      activeSavedSearchId,
      onLoadSavedSearch: toggleModal
    }
  )), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(Button, { onClick: toggleModal }, t("actions.cancel", { ns: "common" }))));
};
export default SavedSearchesModal;
